import React, { useState, useEffect, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import timelinePlugin from '@fullcalendar/timeline';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';

const Calendario = (props) => {
    const { eventos, accion } = props;
    const [date, setDate] = useState(moment('2019-07-30 08:00:00').toDate());
    const calendarRef = useRef(null);

    const accionClick = (info) => {
        console.log('info', info.event.title);
        console.log('info', info.event.start);
        accion({ fecha: info.event.start, titulo: info.event.title });
    };

    return (
        <>
            <FullCalendar
                allDayMaintainDuration
                locale={'es'}
                defaultDate={date}
                // defaultView={view}
                // eventClick={handleEventClick}
                eventClick={accionClick}
                events={eventos}
                header={false}
                height={500}
                buttonText={{ today: 'Hoy' }}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin, timelinePlugin]}
                ref={calendarRef}
                rerenderDelay={10}
                weekends
            />
        </>
    );
};

export default Calendario;
